export const GET_AUTH_PERMISSIONS = "GET_AUTH_PERMISSIONS";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CHANGE_SITE = "CHANGE_SITE";

export const GET_ROLES = "GET_ROLES";
export const GET_USER_ROLES = "GET_USER_ROLES";
export const EDIT_USER_ROLES = "EDIT_USER_ROLES";
export const GET_PERMISSIONS = "GET_PERMISSIONS";
export const GET_ROLE_PERMISSIONS = "GET_ROLE_PERMISSIONS";
export const GET_USER_PERMISSIONS = "GET_USER_PERMISSIONS";

export const GET_USERS = "GET_USERS";
export const CREATE_USER = "CREATE_USER";
export const EDIT_USER = "EDIT_USER";

export const GET_SITES = "GET_SITES";
export const CREATE_SITE = "CREATE_SITE";
export const EDIT_SITE = "EDIT_SITE";
